import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_profession_details = _resolveComponent("profession-details")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, { "router-link": "/home" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: $setup.arrowBack
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createElementVNode("h2", null, _toDisplayString($setup.loading ? '...' : ($setup.profession ? $setup.profession.name : $setup.currProfessionName)), 1),
                          _createElementVNode("p", null, _toDisplayString($setup.profession.nameChinese), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          ($setup.profession == null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ion_spinner)
              ]))
            : (_openBlock(), _createBlock(_component_ion_grid, {
                key: 1,
                fixed: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_profession_details, { profession: $setup.profession }, null, 8, ["profession"])
                ]),
                _: 1
              }))
        ]),
        _: 1
      }),
      ($setup.user.id)
        ? (_openBlock(), _createBlock(_component_ion_footer, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, { class: "ion-text-center" }, {
                default: _withCtx(() => [
                  (!$setup.user.step1OrderedProfessionIds?.split(' , ').includes($setup.profession.id))
                    ? (_openBlock(), _createBlock(_component_ion_button, {
                        key: 0,
                        class: "no-text-transform",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.addToUserTargetProfession($setup.profession)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: $setup.add
                          }, null, 8, ["icon"]),
                          _cache[1] || (_cache[1] = _createTextVNode(" Add to my target profession "))
                        ]),
                        _: 1,
                        __: [1]
                      }))
                    : (_openBlock(), _createBlock(_component_ion_button, {
                        key: 1,
                        class: "no-text-transform",
                        color: "success",
                        disabled: ""
                      }, {
                        default: _withCtx(() => [
                          _cache[2] || (_cache[2] = _createTextVNode(" Added to my target profession ")),
                          _createVNode(_component_ion_icon, {
                            slot: "end",
                            icon: $setup.checkmark
                          }, null, 8, ["icon"])
                        ]),
                        _: 1,
                        __: [2]
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}